import bus from '../../bus'

export function changeCartGoodsNum(goodsNum) {
  bus.state.cartGoodsNum = goodsNum;
}

export function changeOrdersNum(ordersNum) {
  bus.state.ordersNum = ordersNum;
}

export function changeEnableWithholding(enableWithholding) {
  bus.state.enableWithholding = enableWithholding;
}

export function changeUsername(username) {
  bus.state.username = username;
}


export function changeUserOps(ops) {
  bus.state.ops = ops;
}